"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TransactionV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Updated for new UI design (v2)
 * Changes made:
 * 1. Previously, `TransactionAccordion` was called for each code within a transaction.
 *    Now, it is called for each entire transaction.
 * 2. Modified the arguments passed to `TransactionAccordion` to align with the new implementation.
 * 3. Removed code related to 'ZippedCodeBlock'.
 * 4. Replaced the previous accordion implementation with Chakra UI's Accordion component to render each charge.
 */
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@codametrix/ui-components");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var can_drop_1 = require("./can-drop");
var transaction_charge_utils_1 = require("./transaction-charge.utils");
var invoice_meta_info_1 = require("../../code-bench-panel/invoice-meta/invoice-meta-info");
var error_submission_1 = __importDefault(require("../../code-bench-panel/error-submission"));
var svg_icons_1 = __importDefault(require("../../svgs/svg-icons"));
var time_based_code_popover_1 = __importDefault(require("./time-based-code-popover"));
var react_2 = require("@chakra-ui/react");
var react_3 = require("@chakra-ui/react");
var transaction_accordionV2_1 = require("./transaction-accordionV2");
var medical_code_accordion_1 = require("./medical-code-accordion");
var ChargeSessionCodeProvenance = ui_common_1.commonEnums.ChargeSessionCodeProvenance, CodeSearchType = ui_common_1.commonEnums.CodeSearchType;
var draggedCodesManager = ui_common_1.dragManager.load('codes');
var sharedCodePredicate = function (code) {
    //@ts-ignore
    return code.shared === true;
};
var notSharedCodePredicate = function (code) {
    //@ts-ignore
    return !(code.shared === true);
};
/**
 * Method that get data from codable object
 * @param element
 * @param codable
 * @returns
 */
var getDataItem = function (element, codable) {
    var _a;
    var parent = element.closest('.transaction-headerV2');
    if (parent) {
        var codeId_1 = parent.attributes.getNamedItem('data-code');
        var codeType_1 = parent.attributes.getNamedItem('data-code-type');
        if (codeId_1 && codeType_1) {
            return ((_a = codable.codes.find(function (code) {
                return (ui_common_1.cmxTypeguards.isChargeSessionCode(code) &&
                    "".concat(code.code) === "".concat(codeId_1.value) &&
                    code.codeType === "".concat(codeType_1.value));
            })) !== null && _a !== void 0 ? _a : null);
        }
    }
    return null;
};
/**
 * Method that get data from codable object
 * @param element
 * @param codable
 * @returns
 */
var getChipDataItem = function (element, codeInfo, codable) {
    var _a, _b, _c, _d, _e;
    var chipElement = !!element ? element === null || element === void 0 ? void 0 : element.closest('.medical-code-chip') : null;
    var canProceed = !!chipElement || !!codeInfo;
    if (canProceed) {
        var codeId_2 = !!codeInfo
            ? codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code
            : (_b = (_a = chipElement === null || chipElement === void 0 ? void 0 : chipElement.attributes) === null || _a === void 0 ? void 0 : _a.getNamedItem('data-code')) === null || _b === void 0 ? void 0 : _b.value;
        var codeType_2 = ui_common_1.caseUtils.getCodeTypeFullname(!!codeInfo
            ? codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType
            : (_d = (_c = chipElement === null || chipElement === void 0 ? void 0 : chipElement.attributes) === null || _c === void 0 ? void 0 : _c.getNamedItem('data-code-type')) === null || _d === void 0 ? void 0 : _d.value);
        if (codeId_2 && codeType_2) {
            return ((_e = codable.codes.find(function (code) {
                return (ui_common_1.cmxTypeguards.isChargeSessionCode(code) &&
                    "".concat(code.code) === "".concat(codeId_2) &&
                    code.codeType === "".concat(codeType_2));
            })) !== null && _e !== void 0 ? _e : null);
        }
    }
    return null;
};
/**
 * Class React component for render a transaction
 */
var TransactionV2 = /** @class */ (function (_super) {
    __extends(TransactionV2, _super);
    function TransactionV2(props) {
        var _this = _super.call(this, props) || this;
        _this.accordionPanelRef = react_1["default"].createRef();
        _this.triggerRef = react_1["default"].createRef();
        _this.observer = null;
        _this.isTimeBasedCode = function () {
            var _a, _b;
            return (_b = (_a = _this.props.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure) === null || _b === void 0 ? void 0 : _b.time_based;
        };
        _this.handleTimeBasedCodeAdd = function (ev, time, age) {
            ev.preventDefault();
            ev.stopPropagation();
            var _a = _this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
            var element = ev.target;
            var dataItem = getDataItem(element, codableTransaction || chargeSession);
            var changeDetail = {
                codes: [dataItem],
                context: {
                    chargeSession: __assign({}, _this.props.chargeSession),
                    transaction: __assign({}, _this.props.codableTransaction),
                    invoice: __assign({}, _this.props.invoice),
                    processInstance: __assign({}, _this.props.processInstance)
                }
            };
            _this.props.handleTimeBasedCodeAdd(changeDetail, time, age);
            if (_this.lookupRef.current) {
                _this.lookupRef.current.focus();
            }
        };
        _this.handleTimeBasedCodeUpdate = function (ev, time, age) {
            ev.preventDefault();
            ev.stopPropagation();
            var _a = _this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
            var element = ev.target;
            var dataItem = getDataItem(element, codableTransaction || chargeSession);
            var changeDetail = {
                codes: [dataItem],
                context: {
                    chargeSession: __assign({}, _this.props.chargeSession),
                    transaction: __assign({}, _this.props.codableTransaction),
                    invoice: __assign({}, _this.props.invoice),
                    processInstance: __assign({}, _this.props.processInstance)
                }
            };
            _this.props.handleTimeBasedCodeUpdate(changeDetail, time, age);
            if (_this.lookupRef.current) {
                _this.lookupRef.current.focus();
            }
        };
        _this.isClockIconDisabled = function () {
            var _a, _b;
            var procedure = (_a = _this.props.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure;
            var invoice = _this.props.invoice;
            return (procedure &&
                ((_b = invoice === null || invoice === void 0 ? void 0 : invoice.transactions) === null || _b === void 0 ? void 0 : _b.some(function (transaction) {
                    var _a;
                    return ((_a = transaction === null || transaction === void 0 ? void 0 : transaction.procedure) === null || _a === void 0 ? void 0 : _a.add_on_code_id) ===
                        (procedure === null || procedure === void 0 ? void 0 : procedure.additionalProperties['id']);
                })));
        };
        //handle this manually so we can unmount it
        _this.handlePopoverClose = function (newState) {
            _this.setState({ clickTriggered: newState });
        };
        _this.timeBasedCodePopup = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            // Only allow the popover to be open if the trigger is in view
            var popoverState = _this.state.clickTriggered && _this.state.isTriggerInView;
            var handlePopoverOpen = function (ev) {
                // Prevents the default behavior of the click event
                ev.stopPropagation();
                // Toggle the state when the user clicks to open the popover manually
                _this.setState({ clickTriggered: !_this.state.clickTriggered });
            };
            return ((0, jsx_runtime_1.jsxs)(react_2.Popover, __assign({ isOpen: popoverState, placement: "bottom-end", variant: "time", trigger: "click", flip: true, preventOverflow: false, boundary: ((_a = _this.accordionPanelRef) === null || _a === void 0 ? void 0 : _a.current) || 'scrollParent' }, { children: [(0, jsx_runtime_1.jsx)(react_2.PopoverTrigger, { children: (0, jsx_runtime_1.jsxs)(react_2.Button, __assign({ ref: _this.triggerRef, "aria-label": "", variant: "clock", disabled: !_this.props.editable || _this.isClockIconDisabled(), onClick: handlePopoverOpen }, { children: [(0, jsx_runtime_1.jsx)(svg_icons_1["default"], { svgIconName: "BiomeClock", svgIconSize: "20", svgIconClass: ((_c = (_b = _this.props.codableTransaction) === null || _b === void 0 ? void 0 : _b.procedure) === null || _c === void 0 ? void 0 : _c.time_based) &&
                                        ((_e = (_d = _this.props.codableTransaction) === null || _d === void 0 ? void 0 : _d.procedure) === null || _e === void 0 ? void 0 : _e.total_time)
                                        ? 'grey-clock'
                                        : 'color-clock' }), ((_g = (_f = _this.props.codableTransaction) === null || _f === void 0 ? void 0 : _f.procedure) === null || _g === void 0 ? void 0 : _g.time_based) &&
                                    ((_j = (_h = _this.props.codableTransaction) === null || _h === void 0 ? void 0 : _h.procedure) === null || _j === void 0 ? void 0 : _j.total_time) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "total-time" }, { children: _this.props.codableTransaction.procedure.total_time })))] })) }), (0, jsx_runtime_1.jsx)(react_2.Portal, { children: popoverState && ((0, jsx_runtime_1.jsxs)(react_2.PopoverContent, { children: [(0, jsx_runtime_1.jsx)(react_2.PopoverArrow, {}), (0, jsx_runtime_1.jsx)(react_2.PopoverBody, { children: (0, jsx_runtime_1.jsx)(time_based_code_popover_1["default"], { codableTransaction: _this.props.codableTransaction, handleTimeBasedCodeAdd: _this.handleTimeBasedCodeAdd, handleTimeBasedCodeUpdate: _this.handleTimeBasedCodeUpdate, processInstance: _this.props.processInstance, popoverState: popoverState, updatePopoverState: _this.handlePopoverClose }) })] })) })] })));
        };
        _this.toggleAccordion = function () {
            _this.setState(function (prevState) { return ({
                isTransactionRowOpen: !prevState.isTransactionRowOpen
            }); });
        };
        _this.handleUnitsChange = _this.handleUnitsChange.bind(_this);
        _this.handleCodeDelete = _this.handleCodeDelete.bind(_this);
        _this.handleCodesDelete = _this.handleCodesDelete.bind(_this);
        _this.onSearch = _this.onSearch.bind(_this);
        _this.onSearchSelection = _this.onSearchSelection.bind(_this);
        _this.onAddAllCodes = _this.onAddAllCodes.bind(_this);
        _this.onRemoveAllCodes = _this.onRemoveAllCodes.bind(_this);
        _this.onDropHandler = _this.onDropHandler.bind(_this);
        _this.onDragOver = _this.onDragOver.bind(_this);
        _this.onDrop = _this.onDrop.bind(_this);
        _this.onDragLeave = _this.onDragLeave.bind(_this);
        _this.onDelete = _this.onDelete.bind(_this);
        _this.onAccordionAction = _this.onAccordionAction.bind(_this);
        _this.handleCodeChecked = _this.handleCodeChecked.bind(_this);
        _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
        _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
        _this.isTimeBasedCode = _this.isTimeBasedCode.bind(_this);
        _this.timeBasedCodePopup = _this.timeBasedCodePopup.bind(_this);
        _this.codeDropHandler = _this.codeDropHandler.bind(_this);
        _this.lookupRef = react_1["default"].createRef();
        _this.state = {
            dragHover: false,
            clickTriggered: false,
            hasTimeOpened: false,
            isTransactionRowOpen: false,
            isTriggerInView: true,
            isHidingWhileOutOfView: false //is the trigger out of view and the popover needs to be hidden
        };
        return _this;
    }
    /****/
    // Watch for the Popover trigger to go out of view and close it
    /****/
    TransactionV2.prototype.componentDidMount = function () {
        // Create an intersection observer to watch the trigger
        this.setupIntersectionObserver();
    };
    TransactionV2.prototype.componentWillUnmount = function () {
        // Clean up the observer when component unmounts
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    // Set up the intersection observer
    TransactionV2.prototype.setupIntersectionObserver = function () {
        var _this = this;
        var _a;
        // First, clean up any existing observer
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        // Don't proceed if there's no scroll container
        if (!((_a = this.props.scrollContainerRef) === null || _a === void 0 ? void 0 : _a.current)) {
            // Schedule another attempt if the ref isn't ready
            setTimeout(function () { return _this.setupIntersectionObserver(); }, 100);
            return;
        }
        // Don't set up observer if trigger ref isn't available
        if (!this.triggerRef.current) {
            return; // We'll set it up when the ref becomes available
        }
        var options = {
            root: this.props.scrollContainerRef.current,
            rootMargin: '0px',
            threshold: 0.1
        };
        this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                var isInView = entry.isIntersecting;
                _this.setState({ isTriggerInView: isInView });
                // If trigger scrolls out of view while popover is open, close it
                if (!isInView && _this.state.clickTriggered) {
                    _this.setState({
                        isHidingWhileOutOfView: true,
                        clickTriggered: false
                    });
                }
                // If trigger scrolls into view after it had been temp closed, open it again
                if (isInView && _this.state.isHidingWhileOutOfView) {
                    _this.setState({
                        isHidingWhileOutOfView: false,
                        clickTriggered: true
                    });
                }
            });
        }, options);
        // Start observing the trigger element
        this.observer.observe(this.triggerRef.current);
    };
    // Update the component after ref is attached
    TransactionV2.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a, _b, _c, _d;
        // Check if new procedure code was added
        var prevProcedure = (_a = prevProps.codableTransaction) === null || _a === void 0 ? void 0 : _a.procedure;
        var newProcedure = (_b = this.props.codableTransaction) === null || _b === void 0 ? void 0 : _b.procedure;
        var procedureCodeChanged = (prevProcedure === null || prevProcedure === void 0 ? void 0 : prevProcedure.procedure_code) !== (newProcedure === null || newProcedure === void 0 ? void 0 : newProcedure.procedure_code);
        // Check if accordion was just opened
        var accordionJustOpened = !prevState.isTransactionRowOpen && this.state.isTransactionRowOpen;
        var scrollContainerChanged = ((_c = prevProps.scrollContainerRef) === null || _c === void 0 ? void 0 : _c.current) !==
            ((_d = this.props.scrollContainerRef) === null || _d === void 0 ? void 0 : _d.current);
        // If procedure code changed, reset all popover-related states
        if (procedureCodeChanged) {
            this.setState({
                clickTriggered: false,
                hasTimeOpened: false,
                isTriggerInView: true,
                isHidingWhileOutOfView: false
            });
        }
        // This is commented out until we can control the auto open with a config
        // Handle auto-opening for time-based codes
        /* if (newProcedure &&
          !this.state.clickTriggered &&
          !this.state.hasTimeOpened &&
          newProcedure.time_based &&
          newProcedure.add_on_code_available &&
          !newProcedure.total_time) {
        
          // When we need to auto-open, give the DOM time to render first
          setTimeout(() => {
            this.setState({
              clickTriggered: true,
              hasTimeOpened: true,
              isTriggerInView: true,
              isHidingWhileOutOfView: false
            }, () => {
              // After state is updated and component re-renders, set up the observer
              setTimeout(() => this.setupIntersectionObserver(), 50);
              });
            }, 100);
        }  */
        // Always ensure the observer is set up correctly after key changes
        if (accordionJustOpened ||
            scrollContainerChanged ||
            (this.state.clickTriggered && !prevState.clickTriggered)) {
            setTimeout(function () { return _this.setupIntersectionObserver(); }, 50);
        }
    };
    /**
     * Event for drag over
     * @param ev
     */
    TransactionV2.prototype.onDragOver = function (ev) {
        var data = draggedCodesManager.get();
        var searchResult = ui_common_1.cmxTypeguards.isSearchResult(data);
        if (searchResult) {
            var _a = this.props, codableTransaction = _a.codableTransaction, chargeSession = _a.chargeSession;
            var hasCPT = (codableTransaction || chargeSession).codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .some(function (sessionCode) {
                return (sessionCode.provenance.toUpperCase() ===
                    ChargeSessionCodeProvenance.CPT.toUpperCase());
            });
            var allowed = data.codeType.toUpperCase() === ChargeSessionCodeProvenance.CPT
                ? !hasCPT
                : true;
            if (allowed) {
                ev.dataTransfer.dropEffect = 'copy';
                ev.preventDefault();
                if (!this.state.dragHover) {
                    this.setState({ dragHover: true });
                }
            }
        }
    };
    /**
     * Event for drag leaves
     * @param ev
     */
    TransactionV2.prototype.onDragLeave = function (ev) {
        if (this.state.dragHover) {
            this.setState({ dragHover: false });
        }
        ev.dataTransfer.dropEffect = 'none';
    };
    /**
     * Event for drag drops
     * @param ev
     */
    TransactionV2.prototype.onDrop = function (ev) {
        var searchResult = draggedCodesManager.parseEvent(ev);
        draggedCodesManager.clear();
        var codableTransaction = this.props.codableTransaction;
        if (codableTransaction) {
            var codes = codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .filter(function (sessionCode) {
                return (sessionCode.codeType.toUpperCase() ===
                    searchResult.codeType.toUpperCase());
            });
            var result = __assign(__assign({}, searchResult), { context: {
                    invoice: __assign({}, this.props.invoice),
                    transaction: __assign({}, this.props.codableTransaction),
                    chargeSession: __assign({}, this.props.chargeSession),
                    processInstance: __assign({}, this.props.processInstance)
                } });
            codes.push(result);
            this.props.onCodeSearchSelection(__assign(__assign({}, searchResult), { context: {
                    chargeSession: __assign({}, this.props.chargeSession)
                } }));
            this.setState({ dragHover: false });
            if (this.lookupRef.current) {
                this.lookupRef.current.reset();
                this.lookupRef.current.focus();
            }
        }
    };
    /**
     * Event for handle drag drop
     * @param ev
     */
    TransactionV2.prototype.onDropHandler = function (dropAction) {
        var _a = this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
        var dropCandidate = dropAction.dropCandidate, dropTarget = dropAction.dropTarget;
        var sameCodeType = "".concat(dropCandidate.codeType).toUpperCase() ===
            "".concat(dropTarget.codeType).toUpperCase();
        var matchCodes = function (sessionCode) {
            var matchType = "".concat(sessionCode.codeType).toUpperCase() ===
                "".concat(dropCandidate.codeType).toUpperCase();
            var matchProvenance = "".concat(sessionCode.provenance).toUpperCase() ===
                "".concat(dropCandidate.codeType).toUpperCase();
            if (matchProvenance || matchType) {
                return sessionCode.code !== dropCandidate.code;
            }
            return false;
        };
        // remove the code from our code list
        var codes = (codableTransaction || chargeSession).codes
            .filter(matchCodes)
            .filter(ui_common_1.cmxTypeguards.isChargeSessionCode);
        var searchResult = ui_common_1.cmxTypeguards.isSearchResult(dropCandidate);
        var dropCode = dropCandidate;
        if (searchResult) {
            dropCode = {
                code: dropCandidate.code,
                codeType: dropCandidate.codeType,
                description: dropCandidate.description
            };
            var targetPosition = codes.findIndex(function (sessionCode) { return sessionCode.code === dropTarget.code; });
            if (dropAction.position === 'after') {
                targetPosition++;
            }
            codes.splice(targetPosition, 0, dropCode);
            if (this.lookupRef.current) {
                this.lookupRef.current.reset();
                this.lookupRef.current.focus();
            }
        }
        else {
            // if the codes are of the same code type
            // then a drop is just a reordering of the same codes
            // if a drop is on a different code type, then we need
            // to do something different.
            if (sameCodeType) {
                var targetCode_1 = dropTarget.code;
                if (ui_common_1.cmxTypeguards.isZippedCodeBlock(dropCode)) {
                    var blockSet_1 = new Set(dropCode.codes.map(function (code) { return code.code; }));
                    var filteredArray = __spreadArray([], __read(codes), false).filter(function (code) { return !blockSet_1.has(code.code); });
                    var seekPosition = filteredArray.findIndex(function (sessionCode) { return sessionCode.code === dropTarget.code; });
                    if (dropAction.position === 'after') {
                        seekPosition++;
                    }
                    filteredArray.splice.apply(filteredArray, __spreadArray([seekPosition, 0], __read(dropCode.codes), false));
                    codes = filteredArray;
                    // capturing the drag complete for Datadog Action
                    // @ts-ignore
                    window.DD_RUM.addAction('Drag (shared row moved)', {});
                }
                else {
                    // if this is a shared code block then we need to rewind to the
                    // front of the shared codes
                    var codeIncrement = 1;
                    if (ui_common_1.cmxTypeguards.isZippedCodeBlock(dropTarget)) {
                        var _b = __read(dropTarget.codes, 1), firstCode = _b[0];
                        targetCode_1 = firstCode.code;
                        codeIncrement = dropTarget.codes.length;
                    }
                    var targetPosition = codes.findIndex(function (sessionCode) { return sessionCode.code === targetCode_1; });
                    if (dropAction.position === 'after') {
                        targetPosition += codeIncrement;
                    }
                    codes.splice(targetPosition, 0, dropCandidate);
                }
                // capturing the drag complete for Datadog Action
                // @ts-ignore
                window.DD_RUM.addAction('Drag (any code row moved)', {});
            }
            else {
                if (ui_common_1.cmxTypeguards.isZippedCodeBlock(dropCandidate)) {
                    var blockSet_2 = new Set(dropCandidate.codes.map(function (code) { return code.code; }));
                    var filteredArray = __spreadArray([], __read(codes), false).filter(function (code) { return !blockSet_2.has(code.code); });
                    var seekPosition = filteredArray.findIndex(function (sessionCode) { return sessionCode.code === dropTarget.code; });
                    if (dropAction.position === 'after') {
                        seekPosition++;
                    }
                    filteredArray.splice.apply(filteredArray, __spreadArray([seekPosition, 0], __read(dropCandidate.codes), false));
                    codes = filteredArray;
                    // capturing the drag complete for Datadog Action
                    // @ts-ignore
                    window.DD_RUM.addAction('Drag (shared row moved to top)', {});
                }
                else {
                    // there is a defined visual order of codes
                    // PROCEDURES, MODIFIERS, DX
                    // if this changes, then the order will need to be updated
                    var dropIndex = can_drop_1.CODE_ORDER.get("".concat(dropCandidate.codeType));
                    var dropTargetIndex = can_drop_1.CODE_ORDER.get("".concat(dropTarget.codeType));
                    if (dropIndex < dropTargetIndex) {
                        codes.push(dropCandidate);
                    }
                    else {
                        codes.unshift(dropCandidate);
                    }
                    // capturing the drag complete for Datadog Action
                    // @ts-ignore
                    window.DD_RUM.addAction('Drag (invoice code row move to top)', {});
                }
            }
        }
        var changeDetail = {
            codes: codes,
            context: {
                chargeSession: __assign({}, this.props.chargeSession),
                invoice: __assign({}, this.props.invoice),
                transaction: __assign({}, this.props.codableTransaction),
                processInstance: __assign({}, this.props.processInstance)
            }
        };
        this.props.handleCodeSearchDrop(changeDetail);
        this.setState({ dragHover: false });
    };
    TransactionV2.prototype.codeDropHandler = function (codes) {
        var changeDetail = {
            codes: codes,
            context: {
                chargeSession: __assign({}, this.props.chargeSession),
                invoice: __assign({}, this.props.invoice),
                transaction: __assign({}, this.props.codableTransaction),
                processInstance: __assign({}, this.props.processInstance)
            }
        };
        this.props.handleCodeSearchDrop(changeDetail);
    };
    /**
     * Event launched when a search is performed
     * @param ev
     */
    TransactionV2.prototype.onSearch = function (codeQuery) {
        this.props.onCodeSearch(__assign(__assign({}, codeQuery), { context: {
                transaction: __assign({}, this.props.codableTransaction),
                invoice: __assign({}, this.props.invoice),
                chargeSession: __assign({}, this.props.chargeSession),
                processInstance: __assign({}, this.props.processInstance)
            } }));
    };
    /**
     * Event launched when a search selection is pressed
     * @param ev
     */
    TransactionV2.prototype.onSearchSelection = function (searchResult) {
        // check to see if the code is already in the charge session
        var present = this.props.codableTransaction.codes
            .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
            .findIndex(function (sessionCode) {
            return (sessionCode.code === searchResult.code &&
                sessionCode.provenance === searchResult.codeType);
        });
        var searchSelection = __assign(__assign({}, searchResult), { context: {
                defaultPrevented: present !== -1,
                invoice: __assign({}, this.props.invoice),
                transaction: __assign({}, this.props.codableTransaction),
                chargeSession: __assign({}, this.props.chargeSession),
                processInstance: __assign({}, this.props.processInstance)
            } });
        this.props.onCodeSearchSelection(searchSelection);
    };
    TransactionV2.prototype.onAddAllCodes = function (codes) {
        var _this = this;
        var filteredResults = codes.filter(function (result) {
            var present = _this.props.codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .some(function (sessionCode) {
                return (sessionCode.code === result.code &&
                    sessionCode.provenance === result.codeType);
            });
            // Keep the code if it is not existing code
            return !present;
        });
        var searchSelection = {
            codesInfo: filteredResults,
            context: {
                invoice: __assign({}, this.props.invoice),
                transaction: __assign({}, this.props.codableTransaction),
                chargeSession: __assign({}, this.props.chargeSession),
                processInstance: __assign({}, this.props.processInstance)
            }
        };
        this.props.handleAddAllCodes(searchSelection);
    };
    TransactionV2.prototype.onRemoveAllCodes = function (codes) {
        var _this = this;
        var _a = this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
        var codeList = [];
        var existingCodes = codes.filter(function (result) {
            var present = _this.props.codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .some(function (sessionCode) {
                return (sessionCode.code === result.code &&
                    sessionCode.provenance === result.codeType);
            });
            // Keep the code if it is existing code
            return present;
        });
        existingCodes.forEach(function (codeInfo) {
            var chipDataItem = getChipDataItem(null, codeInfo, codableTransaction || chargeSession);
            if (chipDataItem) {
                codeList.push(codeInfo);
            }
        });
        this.handleCodesDelete(codeList);
    };
    /**
     * Event launched when a code is deleted triggered with click on code chip x
     * @param ev
     */
    TransactionV2.prototype.handleCodeDelete = function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.props.editable) {
            var _a = this.props, chargeSession = _a.chargeSession, codableTransaction = _a.codableTransaction;
            var element = ev.target;
            var dataItem = getChipDataItem(element, null, codableTransaction || chargeSession);
            var changeDetail = {
                codes: [dataItem],
                context: {
                    chargeSession: __assign({}, this.props.chargeSession),
                    transaction: __assign({}, this.props.codableTransaction),
                    invoice: __assign({}, this.props.invoice),
                    processInstance: __assign({}, this.props.processInstance)
                }
            };
            this.props.handleCodeRemove(changeDetail);
            if (this.lookupRef.current) {
                this.lookupRef.current.focus();
            }
        }
    };
    /**
     * Event launched when a multiple code are deleted
     * @param ev
     */
    TransactionV2.prototype.handleCodesDelete = function (codes) {
        var _a;
        if (this.props.editable) {
            var _b = this.props, chargeSession_1 = _b.chargeSession, codableTransaction_1 = _b.codableTransaction;
            var dataItems = (_a = codes === null || codes === void 0 ? void 0 : codes.map(function (codeInfo) {
                return getChipDataItem(null, codeInfo, codableTransaction_1 || chargeSession_1);
            })) !== null && _a !== void 0 ? _a : [];
            var changeDetail = {
                codes: dataItems,
                context: {
                    chargeSession: __assign({}, this.props.chargeSession),
                    transaction: __assign({}, this.props.codableTransaction),
                    invoice: __assign({}, this.props.invoice),
                    processInstance: __assign({}, this.props.processInstance)
                }
            };
            if (dataItems)
                this.props.handleRemoveAllCodes(changeDetail);
            if (this.lookupRef.current) {
                this.lookupRef.current.focus();
            }
        }
    };
    /**
     * Event launched when a shared code is toggled.
     * @param ev
     */
    TransactionV2.prototype.handleCodeChecked = function (ev) {
        ev.stopPropagation();
        var codableTransaction = this.props.codableTransaction;
        var action = ev.target.checked ? 'ADD' : 'REMOVE';
        var diagnoses = [];
        if (action === 'REMOVE') {
            diagnoses = [
                {
                    diagnosis_code: ev.target.name,
                    shared: true
                }
            ];
        }
        else if (action === 'ADD') {
            var codes = this.props.codableTransaction.codes
                .filter(ui_common_1.cmxTypeguards.isChargeSessionCode)
                .filter(function (code) { return code.codeType === 'diagnosis'; });
            diagnoses = codes.map(function (code, idx) {
                return {
                    diagnosis_code: code.code,
                    sequence_number: idx + 1,
                    //@ts-ignore
                    shared: code.shared,
                    //@ts-ignore
                    active: code.code === ev.target.name ? true : code.active
                };
            });
        }
        var payload = {
            action: action,
            codeUpdate: {
                transactionGuid: codableTransaction.guid,
                processInstance: this.props.processInstance,
                serviceLine: this.props.processInstance.serviceLine,
                diagnoses: diagnoses
            }
        };
        this.props.onTransactionSharedDiagnosisChange(payload);
    };
    /**
     * Event launched when a units are changed
     * @param ev
     */
    TransactionV2.prototype.handleUnitsChange = function (units, unitsElement) {
        if (this.props.editable) {
            var codableTransaction = this.props.codableTransaction;
            var element = unitsElement;
            var dataItem = getDataItem(element, codableTransaction);
            if (units && (0, transaction_charge_utils_1.isAValidUnits)(units.toString())) {
                this.currentUnit = (0, transaction_charge_utils_1.parseUnits)(parseInt(units.toString()));
                var code = __assign(__assign({}, dataItem), { units: this.currentUnit });
                var changeDetail = {
                    codes: [code],
                    context: {
                        chargeSession: __assign({}, this.props.chargeSession),
                        transaction: __assign({}, this.props.codableTransaction),
                        invoice: __assign({}, this.props.invoice),
                        processInstance: __assign({}, this.props.processInstance)
                    }
                };
                this.props.handleCodeChange(changeDetail);
            }
            else {
                this.currentUnit = (dataItem === null || dataItem === void 0 ? void 0 : dataItem.units) ? Number(dataItem === null || dataItem === void 0 ? void 0 : dataItem.units) : null;
            }
        }
    };
    /**
     * Event launched when a transaction is deleted
     * @param event
     */
    TransactionV2.prototype.onDelete = function (event) {
        event.preventDefault();
        this.props.onChargeSessionAction({
            action: 'DELETE_TRANSACTION',
            chargeSession: this.props.chargeSession,
            meta: {
                invoice: this.props.invoice,
                transaction: __assign({}, this.props.codableTransaction)
            }
        });
    };
    /**
     * Event launched by the accordion
     * @param action
     * @param item
     */
    TransactionV2.prototype.onAccordionAction = function (action, item) {
        var chargeSessionCode = item.data;
        var opening = action === ui_components_1.AccordionSectionAction.OPEN;
        var selection = {
            chargeSessionCode: chargeSessionCode,
            evidence: chargeSessionCode.evidence,
            selectionState: {
                active: false,
                hover: false,
                visible: opening
            }
        };
        this.props.onFeatureSelection(selection);
    };
    /**
     * Method used for enable a procedure with tech/pro charge
     * @param techTransactionCodable
     */
    TransactionV2.prototype.handleEnableTechPro = function (techTransactionCodable) {
        if (this.props.editable) {
            techTransactionCodable.invoice = this.props.invoice;
            this.props.handleEnableTechPro(techTransactionCodable);
        }
    };
    /**
     * Method used for disable a procedure with tech/pro charge
     * @param techTransactionCodable
     */
    TransactionV2.prototype.handleDisableTechPro = function (techTransactionCodable) {
        if (this.props.editable) {
            techTransactionCodable.invoice = this.props.invoice;
            this.props.handleDisableTechPro(techTransactionCodable);
        }
    };
    TransactionV2.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var _f = this.props, chargeSession = _f.chargeSession, codableTransaction = _f.codableTransaction, lineNumber = _f.lineNumber, editable = _f.editable, invoice = _f.invoice, onCodeSearch = _f.onCodeSearch, handleCodeChange = _f.handleCodeChange, handleCodeSearchDrop = _f.handleCodeSearchDrop, handleCodeRemove = _f.handleCodeRemove, canDropOnto = _f.canDropOnto, searchResults = _f.searchResults, codeSearchResultsV2 = _f.codeSearchResultsV2, onCodeSearchSelection = _f.onCodeSearchSelection, onFeatureSelection = _f.onFeatureSelection, onChargeSessionAction = _f.onChargeSessionAction, onEdit = _f.onEdit, autoFocus = _f.autoFocus, panelActivations = _f.panelActivations, processInstance = _f.processInstance, transaction = _f.transaction, debounceTimeout = _f.debounceTimeout, codeEdits = _f.codeEdits, suggestedCodes = _f.suggestedCodes, onTransactionSharedDiagnosisChange = _f.onTransactionSharedDiagnosisChange, rest = __rest(_f, ["chargeSession", "codableTransaction", "lineNumber", "editable", "invoice", "onCodeSearch", "handleCodeChange", "handleCodeSearchDrop", "handleCodeRemove", "canDropOnto", "searchResults", "codeSearchResultsV2", "onCodeSearchSelection", "onFeatureSelection", "onChargeSessionAction", "onEdit", "autoFocus", "panelActivations", "processInstance", "transaction", "debounceTimeout", "codeEdits", "suggestedCodes", "onTransactionSharedDiagnosisChange"]);
        var txnType = (_a = transaction === null || transaction === void 0 ? void 0 : transaction.type) !== null && _a !== void 0 ? _a : 'unknown txn type';
        var styleClasses = [
            'charge-session-informationV2',
            "charge-session-".concat(txnType.toLowerCase()),
            {
                'charge-session-editable': editable,
                'charge-session-uneditable': !editable,
                'charge-session-drop-zone': this.state.dragHover
            }
        ];
        var boundTransactionAccordionBuilder = transaction_accordionV2_1.transactionAccordianBuilderV2.bind(null, this.handleUnitsChange, this.handleCodeDelete, this.handleCodeChecked, this.handleDisableTechPro, this.handleEnableTechPro, this.isTimeBasedCode, this.timeBasedCodePopup, this.onSearch, this.onSearchSelection, this.onAddAllCodes, this.onRemoveAllCodes, this.codeDropHandler, this.onDropHandler, this.onAccordionAction, this.onDelete, suggestedCodes, codeSearchResultsV2, invoice, codeEdits, this.props.editable, autoFocus);
        var boundMedicalCodeAccordionBuilder = medical_code_accordion_1.medicalCodeAccordianBuilder.bind(null, onFeatureSelection, panelActivations, invoice, codeEdits);
        var assuranceErrorMessage = ((_b = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _b === void 0 ? void 0 : _b.errorMessages)
            ? (_c = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _c === void 0 ? void 0 : _c.errorMessages
            : [];
        var sharedCodes = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === ui_common_1.commonEnums.InvoiceTypes.SHARED_CODES;
        var boundMedicalCodeAccordionBuilderHandler = function (code, index) {
            return boundMedicalCodeAccordionBuilder(code, index, codableTransaction, assuranceErrorMessage);
        };
        var boundTransactionAccordionBuilderHandler = function (items) {
            return boundTransactionAccordionBuilder(codableTransaction, transaction, assuranceErrorMessage, items);
        };
        var transactionAccordionItem;
        var items = [];
        if (codableTransaction) {
            var codes = JSON.parse(JSON.stringify((_d = codableTransaction.codes) !== null && _d !== void 0 ? _d : []));
            if (!sharedCodes) {
                var onlyShared = codes.filter(sharedCodePredicate);
                var firstIndex = codes.findIndex(sharedCodePredicate);
                var lastIndex = codes.findIndex(notSharedCodePredicate, firstIndex);
                var preArray = codes.slice(0, firstIndex);
                var postArray = codes.slice(firstIndex + onlyShared.length);
                var zippedShareCodes = {
                    codes: onlyShared,
                    codeType: ui_common_1.commonEnums.CodeType.DIAGNOSIS,
                    zipped: true
                };
                codes = __spreadArray(__spreadArray(__spreadArray([], __read(preArray), false), [zippedShareCodes], false), __read(postArray), false);
            }
            var filtered = codes.filter(function (code) {
                return ui_common_1.cmxTypeguards.isChargeSessionCode(code) ||
                    (ui_common_1.cmxTypeguards.isZippedCodeBlock(code) && code.codes.length);
            });
            items = filtered.map(boundMedicalCodeAccordionBuilderHandler);
            transactionAccordionItem = boundTransactionAccordionBuilderHandler(items);
        }
        // else if (chargeSession) {
        //   items = chargeSession.codes.map(boundAccordionBuilderHandler) as any[];
        //   // TODO: Determine code types
        //   chargeMeta = (
        //     <div className="charge-line">
        //       <span className="charge-index">Charge {lineNumber}:</span>
        //       <span className="charge-charge-type" style={{ display: 'none' }}>
        //         SOME CODE TYPE:
        //       </span>
        //       {editable ? (
        //         <span className="charge-delete-container">
        //           <a href="#/delete-session" onClick={this.onDelete}>
        //             remove
        //           </a>
        //         </span>
        //       ) : (
        //         false
        //       )}
        //     </div>
        //   );
        // }
        else if (transaction) {
            var diagnosis = [];
            var modifiers = [];
            // TODO:
            // const diagnosis = (invoice?.shared_codes.diagnoses ?? []).map(
            //   code => code.diagnosis_code
            // );
            // const modifiers = (invoice?.shared_codes.modifiers ?? []).map(
            //   code => code.modifier_code
            // );
            var dxString = diagnosis.length
                ? "diagnosis: ".concat(diagnosis.join(', '))
                : '';
            var modString = modifiers.length
                ? "modifiers: ".concat(modifiers.join(', '))
                : '';
            var conjunction = diagnosis.length && modifiers.length ? ' and ' : '';
            var alsoIncludes = "".concat(dxString, " ").concat(conjunction, " ").concat(modString);
            styleClasses.push({
                'show-also-includes': diagnosis.length || modifiers.length
            });
            var label = txnType in invoice_meta_info_1.CHARGE_TYPE_LABEL ? invoice_meta_info_1.CHARGE_TYPE_LABEL[txnType] : txnType;
            items = transaction.codes.map(boundMedicalCodeAccordionBuilderHandler);
            transactionAccordionItem = boundTransactionAccordionBuilderHandler(items);
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "code-section" }, { children: transactionAccordionItem ? ((0, jsx_runtime_1.jsx)(react_3.Accordion, __assign({ allowToggle: true, className: "transaction-accordion-section ".concat(this.state.isTransactionRowOpen
                            ? 'transaction-row-expanded'
                            : '') }, { children: (0, jsx_runtime_1.jsxs)(react_3.AccordionItem, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "accordion-header-section" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: 'accordion-header-content', onClick: function (e) { return e.stopPropagation(); } }, { children: transactionAccordionItem.header })), (0, jsx_runtime_1.jsx)(react_3.AccordionButton, __assign({ as: "div", className: "accordion-header-toggle", onClick: this.toggleAccordion }, { children: (0, jsx_runtime_1.jsx)(react_3.AccordionIcon, {}) }))] })), (0, jsx_runtime_1.jsx)(react_3.AccordionPanel, __assign({ className: "accordion-panel-section", ref: this.accordionPanelRef }, { children: transactionAccordionItem.body }))] }) }))) : editable ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message editable" }, { children: "Add codes using the search box below." }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ className: "empty-message uneditable" }, { children: "No codes selected" }))) })), (0, jsx_runtime_1.jsx)(error_submission_1["default"], { errorMessages: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.errorMessages, messageStyle: "txn-error-message", messageType: "error" }), (0, jsx_runtime_1.jsx)(error_submission_1["default"], { errorMessages: (_e = codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.procedure) === null || _e === void 0 ? void 0 : _e.errorMessages, messageStyle: "procedure-error-message", messageType: "error" })] })));
    };
    TransactionV2.displayName = 'Transaction';
    TransactionV2.defaultProps = {
        autoFocus: false,
        searchResults: [],
        codeSearchResultsV2: {},
        editable: true,
        panelActivations: {},
        codeEdits: {},
        debounceTimeout: 200,
        suggestedCodes: {
            cpt: [],
            modifier: [],
            diagnosis: []
        },
        canDropOnto: can_drop_1.canDropOnto,
        onChargeSessionAction: function (transactionAction) { },
        onTransactionSharedDiagnosisChange: function (changeDetail) { },
        handleCodeChange: function (change) { },
        handleCodeRemove: function (change) { },
        handleCodeSearchDrop: function (change) { },
        onCodeSearch: function (codeQuery) { },
        onCodeSearchSelection: function (searchSelection) { },
        handleAddAllCodes: function (searchSelection) { },
        handleRemoveAllCodes: function (codeChange) { },
        onFeatureSelection: function (feature) { },
        onEdit: function (chargeSession) { },
        handleTimeBasedCodeAdd: function (change, time, age) { },
        handleTimeBasedCodeUpdate: function (change, time, age) { }
    };
    return TransactionV2;
}(react_1["default"].Component));
exports.TransactionV2 = TransactionV2;
//# sourceMappingURL=transactionV2.js.map